module.exports = __webpack_public_path__ + "img/file-grey.ace91aae.svg";